import { render, staticRenderFns } from "./Water.vue?vue&type=template&id=2aff0b9c&scoped=true&"
import script from "./Water.vue?vue&type=script&lang=js&"
export * from "./Water.vue?vue&type=script&lang=js&"
import style0 from "./Water.vue?vue&type=style&index=0&id=2aff0b9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff0b9c",
  null
  
)

export default component.exports